import React from "react";
import PropTypes from "prop-types";
import { useBreakpoints } from "@qgiv/core-react";
import { CardGroup } from "@qgiv/core-donor";
import ConnectedStoreItem from "./ConnectedStoreItem";
import "./StoreItemsList.scss";

const StoreItemsList = ({ controlId, productByCategory }) => {
    const { isExtraLargeScreen } = useBreakpoints();
    return (
        <div className="store-items">
            <CardGroup
                legend="Product List"
                colWidth={isExtraLargeScreen ? 6 : 4}
                smallMobileColWidth={6}
            >
                {productByCategory.products.map((product) => {
                    const { id } = product;

                    return (
                        <ConnectedStoreItem
                            key={id}
                            product={product}
                            controlId={controlId}
                        />
                    );
                })}
            </CardGroup>
        </div>
    );
};

StoreItemsList.propTypes = {
    controlId: PropTypes.number.isRequired,
    productByCategory: PropTypes.shape({
        products: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
};

export default StoreItemsList;
